import { useSSRData } from 'hooks';
import { getEnvironment, getBaseUrls } from 'utils';
import getFirstCorrectData from './utils';
import usePlatform from './usePlatform';

const useEnvironmentData = () => {
    const state = useSSRData();
    const platform = usePlatform();
    // eslint-disable-next-line camelcase
    const baseUrls = state?.base_urls;
    const env = getFirstCorrectData(baseUrls?.env, getEnvironment(), '');
    const cdn = getFirstCorrectData(
        baseUrls?.cdn,
        getBaseUrls()?.cdn,
        'https://cdn.manomano.com',
    );

    return {
        env: {
            SERVER_ENV: env,
            IS_DEV: env === 'dev',
            IS_PROD: env === 'prod',
            IS_PRE_PROD: env === 'preprod',
            IS_DEMO: env === 'demo',
        },
        platform: {
            PLATFORM: platform,
            IS_PLATFORM_FR: platform.toUpperCase() === 'FR',
            IS_PLATFORM_IT: platform.toUpperCase() === 'IT',
            IS_PLATFORM_UK: platform.toUpperCase() === 'UK',
            IS_PLATFORM_DE: platform.toUpperCase() === 'DE',
            IS_PLATFORM_ES: platform.toUpperCase() === 'ES',
        },
        cdn: {
            CDN: cdn,
            CDN_IMAGE: `${cdn}/files/dist/img`,
        },
    };
};

export default useEnvironmentData;
